const Result = () => {
  return (
    <div>
      <h2>예산 대비 실적</h2>
    </div>
  );
};

export default Result;
